export default "https://assets.egbcdn.net/assets/packs/_/images/team-logo-0d1d3014d81c2f492b90b0097d219401.svg";